import { useCast } from './hooks/useCast'
import { ProjectSelector } from './components/ProjectSelector'
import { GenerateControls } from './components/GenerateControls'
import { ShotGrid } from './components/ShotGrid'

export function CastTool() {
  const {
    projects,
    activeProject,
    setActiveProject,
    shots,
    grouped,
    jobStatus,
    sequenceJobs,
    mergeJobs,
    hasApiKey,
    loading,
    resolution,
    setResolution,
    generateOne,
    generateSequence,
    dismissSequenceError,
    clearSequence,
    mergeGroup,
    clearMerge,
    doneCount,
    refresh,
  } = useCast()

  const handleGenerateVideo = async (videoId: string) => {
    const videoShots = grouped[videoId]
    if (!videoShots) return
    for (const s of videoShots) {
      const key = `${activeProject}/${s.videoId}/${s.shotId}`
      const job = jobStatus[key]
      if (job?.state === 'generating' || job?.state === 'done') continue
      await generateOne(s)
    }
  }

  const handleGenerateAll = async () => {
    for (const videoId of Object.keys(grouped).sort()) {
      await handleGenerateVideo(videoId)
    }
  }

  if (loading && shots.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-forge-ember border-t-transparent rounded-full animate-spin" />
          <p className="text-forge-ash text-xs tracking-[0.2em] uppercase">Loading Cast</p>
        </div>
      </div>
    )
  }

  return (
    <div className="h-full flex flex-col overflow-hidden">
      {/* Project bar */}
      <div className="flex items-center gap-4 px-5 py-3 bg-forge-obsidian/50 border-b border-forge-border/50">
        <label className="text-[10px] text-forge-ash uppercase tracking-widest">Project</label>
        <ProjectSelector
          projects={projects}
          active={activeProject}
          onChange={setActiveProject}
        />
      </div>

      {/* Controls */}
      <GenerateControls
        resolution={resolution}
        setResolution={setResolution}
        totalShots={shots.length}
        doneCount={doneCount}
        hasApiKey={hasApiKey}
        onRefresh={refresh}
        onGenerateAll={handleGenerateAll}
      />

      {/* Shot grid */}
      <div className="flex-1 overflow-auto p-5">
        <ShotGrid
          grouped={grouped}
          jobStatus={jobStatus}
          sequenceJobs={sequenceJobs}
          mergeJobs={mergeJobs}
          projectId={activeProject}
          onGenerate={(shot, prompt, assetIds) => generateOne(shot, prompt, assetIds)}
          onGenerateVideo={handleGenerateVideo}
          onGenerateSequence={(group, groupShots, opts) => generateSequence(group, groupShots, opts)}
          onDismissSequenceError={dismissSequenceError}
          onClearSequence={clearSequence}
          onMerge={(group, groupShots, transitions) => mergeGroup(group, groupShots, transitions)}
          onClearMerge={clearMerge}
        />
      </div>
    </div>
  )
}
